/**
 * Metafans Media Swiper
 * Initializes Swiper for image galleries in the activity stream.
 */

export function initSwiper() {
    // Initial check
    const stream = document.getElementById('activity-stream');
    if (!stream) return;

    // Run once on load
    initializeSliders(stream);

    // Observer for new activities (Load More / Infinite Scroll)
    const observer = new MutationObserver((mutations) => {
        // Debounce logic could be added here if stream updates are frequent
        initializeSliders(stream);
    });

    observer.observe(stream, { childList: true, subtree: true });
}

function initializeSliders(container) {
    const sliders = container.querySelectorAll('.post-media.bp-image-previewer');

    sliders.forEach((sliderEl, index) => {
        // Prevent double initialization
        if (sliderEl.classList.contains('swiper-initialized')) return;

        // Check valid slides (must be .bp-image-single)
        const validSlides = sliderEl.querySelectorAll('.bp-image-single');
        // Only initialize if we have enough slides (>= 3 per original logic, though 1+ usually warrants a slider)
        if (validSlides.length < 3) return;

        // Structure DOM for Swiper (add wrapper)
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');

        // Move children into wrapper
        [...sliderEl.children].forEach(child => {
            child.classList.add('swiper-slide');
            wrapper.appendChild(child);
        });

        sliderEl.innerHTML = '';
        sliderEl.appendChild(wrapper);
        sliderEl.classList.add('swiper');
        sliderEl.setAttribute('data-swiper-id', `swiper-${index}`);

        // Initialize Swiper (Check if library exists)
        if (typeof window.Swiper !== 'undefined') {
            new window.Swiper(sliderEl, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                pagination: false,
                navigation: false,
                touchStartPreventDefault: false, // Better mobile scroll handling
                on: {
                    touchStart(swiper, event) {
                        const slide = event.target.closest('.swiper-slide');
                        if (slide) {
                            slide.style.transition = 'transform 0.2s ease';
                            slide.style.transform = 'scale(0.98)';
                        }
                    },
                    touchEnd(swiper, event) {
                        const slide = event.target.closest('.swiper-slide');
                        if (slide) {
                            slide.style.transform = 'scale(1)';
                        }
                    }
                }
            });
            sliderEl.classList.add('swiper-initialized');
        }
    });
}